run.$inject = ['$rootScope', '$templateCache', '$state', '$stateParams', '$timeout', 'MenuConstant', 'portfolio']

export default function run ($rootScope, $templateCache, $state, $stateParams, $timeout, MenuConstant, portfolio) {
  MenuConstant[0]['menu'].push(portfolio)
}



// WEBPACK FOOTER //
// ./src/app/u-faculty/portfolio/portfolio.run.js